// NoIndex.js
import { Helmet } from 'react-helmet-async';

// Keeps a page out of search engine indexes.
const NoIndex = () => (
  <Helmet>
    <meta name="robots" content="noindex" />
  </Helmet>
);

export default NoIndex;
